<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(localizedFormat);

const store = useStore();

const traffic_record = computed(
  () => store.state.trafficRecordComponent.traffic_record
);

const loading = computed(() => store.state.globals.loading);
</script>

<template>
  <div class="col-md-12 col-lg-6 col-xl-4 mb-0">
    <b-overlay :show="loading">
      <div class="card" v-if="traffic_record.reviewer.inputApproved || traffic_record.reviewer.verifyApproved || traffic_record.reviewer.validateApproved">
        <div class="card-body overflow-auto">
          <table class="table table-bordered table-sm table-light m-0">
            <tbody>
              <tr>
                <th colspan="2" class="text-center">Reviewer Details</th>
              </tr>
              <tr v-if="traffic_record.reviewer.inputApproved">
                <td class="no-wrap">Mismatch Reviewer</td>
                <td>{{ (traffic_record.reviewer.inputApproved) ? traffic_record.reviewer.inputApproved + ' (' + dayjs(traffic_record.reviewer.inputDate).format('ddd, LL hh:mm:ss A') + ')' : "n/a" }}</td>
              </tr>
              <tr v-if="!traffic_record.reviewer.inputApproved && traffic_record.reviewer.verifyApproved">
                <td class="no-wrap">1st Review</td>
                <td>{{ (traffic_record.reviewer.verifyApproved) ? traffic_record.reviewer.verifyApproved + ' (' + dayjs(traffic_record.reviewer.verifyDate).format('ddd, LL hh:mm:ss A') + ')' : "n/a" }}</td>
              </tr>
              <tr v-if="traffic_record.reviewer.validateApproved && traffic_record.reviewer.validateApproved != traffic_record.reviewer.verifyApproved">
                <td class="no-wrap">2nd Review</td>
                <td>{{ (traffic_record.reviewer.validateApproved) ? traffic_record.reviewer.validateApproved + ' (' + dayjs(traffic_record.reviewer.validateDate).format('ddd, LL hh:mm:ss A') + ')' : "n/a" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<style scoped>
.no-wrap {
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
td {
  padding: 5px;
}
</style>
